var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { isEditableDiagramNode } from './collect';
/** Add a transparent hit area so diagram nodes receive pointer events. */
export function attachNodeHitTarget(app, node) {
    var e_1, _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if ((_b = node.metadata) === null || _b === void 0 ? void 0 : _b.hitTargetAttached)
        return;
    var cardW = ((_d = (_c = node.metadata) === null || _c === void 0 ? void 0 : _c.orgCardWidth) !== null && _d !== void 0 ? _d : (_e = node.metadata) === null || _e === void 0 ? void 0 : _e.diagramCardWidth);
    var cardH = ((_g = (_f = node.metadata) === null || _f === void 0 ? void 0 : _f.orgCardHeight) !== null && _g !== void 0 ? _g : (_h = node.metadata) === null || _h === void 0 ? void 0 : _h.diagramCardHeight);
    var hx = 0;
    var hy = 0;
    var w;
    var h;
    if (typeof cardW === 'number' && typeof cardH === 'number' && cardW > 0 && cardH > 0) {
        w = cardW;
        h = cardH;
    }
    else {
        // Prefer local children AABB over Group.getBounds() (world) for nested trees
        var minX = 0;
        var minY = 0;
        var maxX = 40;
        var maxY = 32;
        if (node.children.length > 0) {
            minX = Infinity;
            minY = Infinity;
            maxX = -Infinity;
            maxY = -Infinity;
            try {
                for (var _m = __values(node.children), _o = _m.next(); !_o.done; _o = _m.next()) {
                    var child = _o.value;
                    if ((_j = child.metadata) === null || _j === void 0 ? void 0 : _j.isDiagramHitTarget)
                        continue;
                    if ((_k = child.metadata) === null || _k === void 0 ? void 0 : _k.orgNode)
                        continue;
                    var cb = child.getBounds();
                    minX = Math.min(minX, child.x + cb.x);
                    minY = Math.min(minY, child.y + cb.y);
                    maxX = Math.max(maxX, child.x + cb.x + cb.width);
                    maxY = Math.max(maxY, child.y + cb.y + cb.height);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_o && !_o.done && (_a = _m.return)) _a.call(_m);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (!Number.isFinite(minX)) {
                minX = 0;
                minY = 0;
                maxX = 40;
                maxY = 32;
            }
        }
        hx = minX;
        hy = minY;
        w = Math.max(maxX - minX, 24);
        h = Math.max(maxY - minY, 24);
    }
    var hit = app.rect({
        x: hx,
        y: hy,
        width: w,
        height: h,
        fill: 'rgba(0,0,0,0.001)',
        stroke: null,
        listening: true,
    });
    hit.metadata.isDiagramHitTarget = true;
    hit.metadata.hitTargetFor = (_l = node.metadata) === null || _l === void 0 ? void 0 : _l.diagramId;
    node.add(hit);
    node.draggable = true;
    node.listening = true;
    node.metadata.hitTargetAttached = true;
    node.metadata.editorBaseScaleX = node.scaleX;
    node.metadata.editorBaseScaleY = node.scaleY;
    node.metadata.editorBaseW = w;
    node.metadata.editorBaseH = h;
}
export function ensureEditableHitTargets(app, root) {
    var walk = function (parent) {
        var e_2, _a;
        var _b;
        try {
            for (var _c = __values(parent.children), _d = _c.next(); !_d.done; _d = _c.next()) {
                var child = _d.value;
                if (isEditableDiagramNode(child)) {
                    attachNodeHitTarget(app, child);
                }
                if ('children' in child && ((_b = child.children) === null || _b === void 0 ? void 0 : _b.length)) {
                    walk(child);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    walk(root);
}
export function tagEdgeLayer(root) {
    var walk = function (parent) {
        var e_3, _a;
        try {
            for (var _b = __values(parent.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                if (child.zIndex === -10 && child.type === 'group') {
                    child.metadata.diagramEdgeLayer = true;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    walk(root);
}
